var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M512 426.666V85.329H0v341.337h512z",
  fill: "#6da544"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M512 85.331H0v170.666h512V85.331z",
  fill: "#d80027"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.334h181.793v341.337H0z"
})));

export default SvgMg;